/* eslint-disable */
import detectionCnf from './reducer/index';

export default {
  detectionCnf,
};
